import { useEffect } from 'react';
import { UseFormReset } from 'react-hook-form';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import {
  McpAccess,
  TenantApplicationConfigurationNonSsoLoginMechanism,
  TenantApplicationConfigurationUserSessionInactivityTimeout,
} from '@/types/schema';

import { useTenantConfigurationFormQuery } from '../graphql/TenantConfigurationForm.generated';
import { TenantConfigurationFormShape } from '../TenantConfigurationForm.constants';

export function useTenantConfigurationFormDefaultValues(
  reset: UseFormReset<TenantConfigurationFormShape>
) {
  // const { reset } = useFormContext<TenantConfigurationFormShape>();
  const { createErrorFeedback } = useFeedback();

  const { data, ...queryProps } = useTenantConfigurationFormQuery({
    onError: createErrorFeedback(
      'There was an error fetching tenant configuration details. Please refresh the page to try again.'
    ),
  });

  useEffect(() => {
    if (!data) return;
    const formData: TenantConfigurationFormShape = {
      collaboratorDomainAllowList: (
        data.tenantApplicationConfiguration?.collaboratorDomainAllowList ?? []
      ).map((domain) => ({ value: domain })),
      disableAiCapabilities:
        data.tenantApplicationConfiguration?.disableAiCapabilities || false,
      disableAiInsights:
        data.tenantApplicationConfiguration?.disableAiInsights || false,
      enableEmployeeIdpId:
        data.tenantApplicationConfiguration?.enableEmployeeIdpID || false,
      mcpAccess:
        data.tenantApplicationConfiguration?.mcpAccess ?? McpAccess.Off,
      smartReviewEnabled:
        data.tenantApplicationConfiguration?.smartReviewEnabled ?? true,
      userSessionInactivityTimeout:
        data.tenantApplicationConfiguration?.userSessionInactivityTimeout ||
        TenantApplicationConfigurationUserSessionInactivityTimeout.Off,
      nonSsoLoginMechanism:
        data.tenantApplicationConfiguration?.nonSSOLoginMechanism ||
        TenantApplicationConfigurationNonSsoLoginMechanism.MagicLink,
    };
    reset(formData);
  }, [data, reset]);

  return {
    data,
    ...queryProps,
  };
}
